<template>
  <div class="profile-input-wrapper">
    <profile-form ref="form" endpoint="personalinformation" @error="$emit('done', $event)">
      <form class="form">
        <fieldset>
          <legend class="sr-only">{{inputTitle}}</legend>
          <div class="input dropdow">
            <select
              v-model="localProfile.title"
              :class="[{ 'no-value': !localProfile.title }, { 'valid': !!localProfile.title }]"
              class="req"
              name="title"
              data-val="true"
              :data-val-required="getValidationForField('required', 'title')"
              data-field-type="DropdownList"
            >
              <option
                v-for="title in userTitles"
                :key="title.value"
                :value="title.value">
                  {{title.label}}
                </option>
            </select>
            <label for="title" class="floating req">
              {{tc('profile.formFields.title')}}
            </label>
            <span data-valmsg-for="title" data-valmsg-replace="true" class="field-validation-valid"></span>
          </div>
          <div class="input">

            <input
              v-model="localProfile.firstName"
              :class="[{ 'no-value': !localProfile.firstName }, { 'valid': !!localProfile.firstName }]"
              type="text"
              id="firstName"
              name="firstName"
              maxlength="255"
              class="req"
              data-val="true"
              data-rule-minlength="1"
              data-rule-maxlength="50"
              :data-msg-minlength="getValidationForField('minChars', '1')"
              :data-msg-maxlength="getValidationForField('maxChars', '50')"
              :data-val-required="getValidationForField('required', 'firstName')"
              :data-val-no-special-chars="tc('validations.noSpecialChars')"
              data-field-type="SingleLineText"
            >

            <label for="firstName" class="req floating">
                {{tc('profile.formFields.firstName')}}
            </label>

            <span data-valmsg-for="firstName" data-valmsg-replace="true" class="field-validation-valid"></span>
          </div>
          <div class="input">

            <input
              v-model="localProfile.lastName"
              :class="[{ 'no-value': !localProfile.lastName }, { 'valid': !!localProfile.lastName }]"
              class="req"
              type="text"
              id="lastName"
              name="lastName"
              maxlength="255"
              data-val="true"
              data-rule-minlength="1"
              data-rule-maxlength="65"
              :data-msg-minlength="getValidationForField('minChars', '1')"
              :data-msg-maxlength="getValidationForField('maxChars', '65')"
              :data-val-required="getValidationForField('required', 'lastName')"
              :data-val-no-special-chars="tc('validations.noSpecialChars')"
              data-field-type="SingleLineText"
            >

            <label for="lastName" class="req floating">
                {{tc('profile.formFields.lastName')}}
            </label>

            <span data-valmsg-for="lastName" data-valmsg-replace="true" class="field-validation-valid"></span>
          </div>
        </fieldset>
      </form>
    </profile-form>
  </div>
</template>

<script>
import ProfileInputMixin from '@mixins/profile-input-mixin'
export default {
  name: 'profile-name-input',
  mixins: [ProfileInputMixin],
  props: {
    userTitles: {
      type: Array,
      required: true
    },
  },
  data: () => ({
    localProfile: {
      title: '',
      firstName: '',
      lastName: ''
    }
  }),
}
</script>
